import { render, staticRenderFns } from "./HowProcess.vue?vue&type=template&id=22171756&scoped=true&"
import script from "./HowProcess.vue?vue&type=script&lang=js&"
export * from "./HowProcess.vue?vue&type=script&lang=js&"
import style0 from "./HowProcess.vue?vue&type=style&index=0&id=22171756&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22171756",
  null
  
)

export default component.exports